import { Marker } from '@vis.gl/react-google-maps';
import React from 'react';
import factoryIcon from '../assets/factory.svg';
import { Factory } from 'views/delivery-board/types/factory.type';

type Props = { factory: Factory; activeMarker: string };

const FactoryMarker: React.FC<Props> = ({ factory, activeMarker }) => {
  return (
    <Marker
      title={factory.factoryName}
      icon={{
        url: factoryIcon,
        size: new google.maps.Size(32, 38),
        scaledSize: new google.maps.Size(32, 38),
        labelOrigin: new google.maps.Point(15, -11),
      }}
      zIndex={10}
      key={factory.sapCode}
      position={{ lat: Number(factory.factoryLocation.latitude), lng: Number(factory.factoryLocation.longitude) }}
      opacity={activeMarker?.includes(String(factory.sapCode)) ? 1 : activeMarker === '' ? 1 : 0.6}
      label={{ text: `${factory.factoryName}`, color: '#fff', fontSize: '16px', fontWeight: '400' }}
    />
  );
};

export default React.memo(FactoryMarker);
